import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import "./Sidebar.css";
import logo from '../../Images/shyam-logo.jpg'
const Navbar = ({ onLogout }) => {
  const [dropdown, setDropdown] = useState(false);
  const [examDropdown, setExamDropdown] = useState(false);
  const [infoDropdown, setInfoDropdown] = useState(false);
  const [hallTicketDropdown, setHallTicketDropdown] = useState(false);
  const [coursesDropdown, setCoursesDropdown] = useState(false);
  const [mobileMenu, setMobileMenu] = useState(false);
  const [blogsDropdown, setBlogsDropdown] = useState(false);

  const toggleDropdown = () => setDropdown(!dropdown);
  const toggleExamDropdown = () => setExamDropdown(!examDropdown);
  const toggleInfoDropdown = () => setInfoDropdown(!infoDropdown);
  const toggleHallTicketDropdown = () => setHallTicketDropdown(!hallTicketDropdown);
  const toggleCoursesDropdown = () => setCoursesDropdown(!coursesDropdown);
  const toggleMobileMenu = () => setMobileMenu(!mobileMenu);
  const toggleBlogsDropdown = () => setBlogsDropdown(!blogsDropdown);

  const closeMobileMenu = () => setMobileMenu(false);

  return (
    <nav className="admin-navbar">
      <div className="admin-navbar-logo">
        <Link to="/"><img src={logo} alt="Poster" /></Link>
      </div>
      <div className={`admin-navbar-menu ${mobileMenu ? "active" : ""}`}>
        <ul className="admin-navbar-links">
          <li>
            <Link to="/" onClick={closeMobileMenu}>Homepage</Link>
          </li>
          <li>
            <div className="admin-navbar-dropdown" onClick={toggleDropdown}>
              <Link to="#">About</Link>
              <span className="admin-navbar-dropdown-icon">
                {dropdown ? "▲" : "▼"}
              </span>
              {dropdown && (
                <ul className="admin-navbar-dropdown-menu">
                  <li><Link to="/chairmanmessage" onClick={closeMobileMenu}>Chairman Message</Link></li>
                  <li><Link to="/methodology" onClick={closeMobileMenu}>Syam Methodology</Link></li>
                  <li><Link to="/missionAndVision" onClick={closeMobileMenu}>Mission And Vision</Link></li>
                </ul>
              )}
            </div>
          </li>

          <li>
            <div className="admin-navbar-dropdown" onClick={toggleCoursesDropdown}>
              <Link to="#">Courses</Link>
              <span className="admin-navbar-dropdown-icon">
                {coursesDropdown ? "▲" : "▼"}
              </span>
              {coursesDropdown && (
                <ul className="admin-navbar-dropdown-menu">
                  <li><Link to="/courses" onClick={closeMobileMenu}>Courses</Link></li>
                  <li><Link to="/faq" onClick={closeMobileMenu}>FAQs</Link></li>
                </ul>
              )}
            </div>
          </li>
          <li>
            <div className="admin-navbar-dropdown" onClick={toggleExamDropdown}>
              <Link to="#">Exams</Link>
              <span className="admin-navbar-dropdown-icon">
                {examDropdown ? "▲" : "▼"}
              </span>
              {examDropdown && (
                <ul className="admin-navbar-dropdown-menu">
                  <li><Link to="/calender" onClick={closeMobileMenu}>Exam Calendar</Link></li>
                  <li><Link to="/results" onClick={closeMobileMenu}>Exam Results</Link></li>
                  <li><Link to="/pqns" onClick={closeMobileMenu}>Previous Question Papers</Link></li>
                  <li><Link to="/notificationCentre" onClick={closeMobileMenu}>Notification Centre</Link></li>
                </ul>
              )}
            </div>
          </li>
          <li>
            <Link to="/materials" onClick={closeMobileMenu}>Materials</Link>
          </li>
          <li>
            <div className="admin-navbar-dropdown" onClick={toggleInfoDropdown}>
              <Link to="#">Information Center</Link>
              <span className="admin-navbar-dropdown-icon">
                {infoDropdown ? "▲" : "▼"}
              </span>
              {infoDropdown && (
                <ul className="admin-navbar-dropdown-menu">
                  <li><Link to="/batches" onClick={closeMobileMenu}>Upcoming Batches</Link></li>
                  <li><Link to="/centers" onClick={closeMobileMenu}>Our Centres</Link></li>
                </ul>
              )}
            </div>
          </li>



          <li>
            <div className="admin-navbar-dropdown" onClick={toggleBlogsDropdown}>
              <Link to="#">Blogs</Link>
              <span className="admin-navbar-dropdown-icon">
                {blogsDropdown ? "▲" : "▼"}
              </span>
              {blogsDropdown && (
                <ul className="admin-navbar-dropdown-menu">
                  <li><Link to="/categories" onClick={closeMobileMenu}>Category management</Link></li>
                  <li><Link to="/create-blog" onClick={closeMobileMenu}>Create blog</Link></li>
                  <li><Link to="/blog-list" onClick={closeMobileMenu}>Blog list</Link></li>
                </ul>
              )}
            </div>
          </li>



          <li><Link to="/success-stories" onClick={closeMobileMenu}>Success Stories</Link></li>
          <li><Link to="/portfolio" onClick={closeMobileMenu}>Gallery</Link></li>
          <li>
            <div className="admin-navbar-dropdown" onClick={toggleHallTicketDropdown}>
              <Link to="#">HallTickets management</Link>
              <span className="admin-navbar-dropdown-icon">
                {hallTicketDropdown ? "▲" : "▼"}
              </span>
              {hallTicketDropdown && (
                <ul className="admin-navbar-dropdown-menu">
                  <li><Link to="/halltickets" onClick={closeMobileMenu}>HallTickets</Link></li>
                  <li><Link to="/zones" onClick={closeMobileMenu}>Zones</Link></li>
                  <li><Link to="/exam-centres" onClick={closeMobileMenu}>Manage Exam Centres</Link></li>
                  <li><Link to="/codeformat" onClick={closeMobileMenu}>HallTicket Format for Centres</Link></li>
                  <li><Link to="/subscriptionPrice" onClick={closeMobileMenu}>Manage Subscription Price Details</Link></li>
                </ul>
              )}
            </div>
          </li>
          <li><Link to="/contact" onClick={closeMobileMenu}>Contact</Link></li>
          <li><Link to="/popups" onClick={closeMobileMenu}>PopUps</Link></li>
          <li><Link to="/user" onClick={closeMobileMenu}>Users</Link></li>
          <li><Link to="/Orders" onClick={closeMobileMenu}>orders</Link></li>
          <li><button className="admin-navbar-logout-btn" onClick={() => { closeMobileMenu(); onLogout(); }}>Logout</button></li>
        </ul>
      </div>
      <div className="admin-navbar-hamburger" onClick={toggleMobileMenu}>
        &#9776;
      </div>
    </nav>
  );
};

export default Navbar;
